<template lang="pug">
v-autocomplete(
  v-model="internalValue"
  label="Selecciona un producto"
  :search-input.sync="search"
  outlined
  no-filter
  item-text="name"
  return-object
  @focus="searchDebounced"
  @change="$emit('change', $event)"
  :items="items"
  :loading="loading"
  :hide-no-data="hideNoData"
  :hide-details="hideDetails"
  no-data-text="No se encontraron productos"
  :rules="rules")
    template(v-slot:item="{ item }")
      v-list-item-content
        v-list-item-title {{ item.name }}
        v-list-item-subtitle SKU: {{ item.sku }}
</template>

<script>
import { debounce } from 'debounce'
import { mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Object,
      default: null
    },
    rules: {
      type: Array,
      default: () => []
    },
    hideDetails: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      search: null,
      searchDebounced: debounce(this.handleSearch, 500),
      items: [],
      internalValue: this.value ? { ...this.value } : null,
      loading: false,
      hideNoData: true,
    }
  },

  watch: {
    search (value) {
      this.searchDebounced()
    },
    internalValue (value) {
      this.$emit('input', value)
    },
    value (value) {
      this.internalValue = value
      if (value) {
        this.items = [value, ...this.items]
      }
    }
  },

  methods: {
    ...mapActions('product', [
      'listProducts'
    ]),
    async handleSearch () {
      this.loading = true
      const params = {
        search: this.search,
        page_size: 10
      }
      const { data, error } = await this.listProducts({ params })
      if (!error) {
        this.items = data.results
      }
      this.loading = false
      this.hideNoData = false
    }
  }
}
</script>